// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Message__message-b33f3e {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  padding: 8px 16px;
  cursor: pointer;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-110);
}
.Message__message-b33f3e:hover {
  background-color: var(--base-17);
}
@supports (display: block) {
  .Message__message-b33f3e:focus-visible {
    background-color: var(--base-17);
  }
}
.Message__message-b33f3e.Message__active-ca7958 {
  background-color: var(--base-20);
}

.Message__avatar-ffc08d {
  flex: 0 0 auto;
  margin-inline-end: 12px;
}

.Message__body-b35694 {
  flex: 1;
  overflow: hidden;
}

.Message__header-a2c2f2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

.Message__sender-name-wrapper-f9979d {
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-inline-end: 8px;
}

.Message__badges-d6de81 {
  margin-inline-start: 6px;
}

.Message__senderName-af2d50 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.Message__date-d200b9 {
  flex: 0 0 auto;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.Message__text-a4eb8b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-110);
}

.Message__selection-a52cc3 {
  background: var(--brand-primary-10);
  border-radius: 4px;
}
.Message__selection-a52cc3:empty {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/SearchMessages/Message/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;AACE;EACE,gCAAA;AACJ;AACE;EACE;IACE,gCAAA;EACJ;AACF;AAEE;EACE,gCAAA;AAAJ;;AAIA;EACE,cAAA;EACA,uBAAA;AADF;;AAIA;EACE,OAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AADF;;AAIA;EACE,cAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AADF;;AAIA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AADF;;AAIA;EACE,mCAAA;EACA,kBAAA;AADF;AAEE;EACE,aAAA;AAAJ","sourcesContent":[".message {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  overflow: hidden;\n  padding: 8px 16px;\n  cursor: pointer;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-110);\n\n  &:hover {\n    background-color: var(--base-17);\n  }\n  @supports (display: block) {\n    &:focus-visible {\n      background-color: var(--base-17);\n    }\n  }\n\n  &.active {\n    background-color: var(--base-20);\n  }\n}\n\n.avatar {\n  flex: 0 0 auto;\n  margin-inline-end: 12px;\n}\n\n.body {\n  flex: 1;\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n}\n\n.sender-name-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  margin-inline-end: 8px;\n}\n\n.badges {\n  margin-inline-start: 6px;\n}\n\n.senderName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.date {\n  flex: 0 0 auto;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-110);\n}\n\n.selection {\n  background: var(--brand-primary-10);\n  border-radius: 4px;\n  &:empty {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `Message__message-b33f3e`,
	"active": `Message__active-ca7958`,
	"avatar": `Message__avatar-ffc08d`,
	"body": `Message__body-b35694`,
	"header": `Message__header-a2c2f2`,
	"sender-name-wrapper": `Message__sender-name-wrapper-f9979d`,
	"senderNameWrapper": `Message__sender-name-wrapper-f9979d`,
	"badges": `Message__badges-d6de81`,
	"senderName": `Message__senderName-af2d50`,
	"date": `Message__date-d200b9`,
	"text": `Message__text-a4eb8b`,
	"selection": `Message__selection-a52cc3`
};
module.exports = ___CSS_LOADER_EXPORT___;
